// extracted by mini-css-extract-plugin
export default {"Notification":"styles_Notification__WcypK","visible":"styles_visible__VuJgT","undoButton":"styles_undoButton__803oA"};